import React, { Component, Fragment } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import { Typography, Tooltip, Box } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import FormControl from '@material-ui/core/FormControl';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DefaultSettings from './settings';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';

const styles = {
    root: {
        flexGrow: 1,
    },
    switchBase: {
        color: red[800],
        '&$checked': {
            color: green[700],
        },
        '&$checked + $track': {
            backgroundColor: green[700],
        },
    },
    checked: {},
    track: {},
    thumb: {
        // marginTop: '5px !important',
        width: 28,
        height: 28,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
            fontSize: 16,
            marginTop: 10,
        },
    },
};

const GreenSwitch = withStyles(styles)(({ classes, ...props }) => (
    <Switch
        {...props}
        classes={{
            switchBase: classes.switchBase,
            checked: classes.checked,
            track: classes.track,
            //  thumb: classes.thumb,
        }}
        icon={<CancelIcon fontSize='inherit' style={{ marginTop: '7px' }} />}
        checkedIcon={<CheckCircleIcon fontSize='inherit' style={{ marginTop: '7px' }} />}
    />
));

const FormSwitch = (props) => {
    const { handleFieldValue, value, name, error, label, tooltip, contexthelp, extraProps, disabled, edit, conditions, helperText, required } = props;
    const { transformProps } = extraProps || {};
    let disabledstatus = conditions && conditions.enable ? conditions.enable : disabled;

    const handlefieldchange = (e) => {
        const { name, checked } = e.target;
        let value = transformProps[checked];
        const { dataset } = e.currentTarget;
        handleFieldValue({ target: { name: name, value: value, checked: checked }, currentTarget: { dataset: dataset } });
    };

    let tlabel = (tooltip || contexthelp) ? (
        <Typography variant={'subtitle2'} style={{ color: props.errors ? 'red' : disabled ? disabled : 'black' }}>
            {label}&nbsp;
            <Tooltip title={tooltip ? tooltip : null} placement="bottom-start">
                <HelpOutlineIcon fontSize="small" style={{ width: '0.8em', color: '#007bff' }} onClick={(evt) => contexthelp ? DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
            </Tooltip>
        </Typography>
    ) : <Typography style={props.labelPlacement === 'top' ? { fontSize: 10, padding: 0, margin: 0, fontWeight: 'bold' } : {}}>{label}</Typography>;

    return (
        <Fragment>
            <FormControl required={props.required} error={error || false}>
                <FormControlLabel
                    control={
                        <GreenSwitch
                            checked={value ? (transformProps ? transformProps[value] : value) : false}
                            onChange={handlefieldchange}
                            name={name}
                            disabled={disabledstatus || false}
                        />
                    }
                    labelPlacement={props.labelPlacement || 'end'}
                    label={tlabel || ''}
                />
                {/* // FormHelperText is used to display the error message in red in colour and in small font */}
                {error && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
        </Fragment>
    );
};

export default withStyles(styles)(FormSwitch);